
import DataSet from '@antv/data-set';
import { addDays, format } from 'date-fns';
import { cloneDeep } from 'lodash-es';
import {
    buttonList,
    ChartsType,
    SelectorsType,
    ConditionsType,
    FilterFormItemType,
    PanelsType,
    NewChartListConfigType,
    NewSelectorConfigType,
    ChartType
} from './types';

export const defaultRetentionCardTime = addDays(new Date(), -7).getTime();



/**
 * 过滤chart里符合条件的selectors；举个例子：
 * const oldConfig =  {
    "chartId": 2429,
    "chartName": "收入数据概览-折线",
    "selectors": [
        {
            "fieldName": "ad_impression_num",
            "displayName": "广告请求PV",
            "displaySetting": "{\"color\":\"#1D59F2\",\"gameType\":[\"iaa\",\"iaap\"],\"unit\":\"次\"}",
            ...其他原有参数
        },
        {
            "fieldName": "pay_user_uv",
            "displayName": "付费人数",
            "displaySetting": "{\"color\":\"#078F59\",\"gameType\":[\"iaap\"],\"unit\":\"次\"}",
            ...
        },

        {
            "fieldName": "p_date",
            "displaySetting": "{\"gameType\":[\"iaa\",\"iaap\", \"iap\"]}",
            "propertyType": "dimension"
            ...
        }
    ],
    ...
}
输出：假设当前游戏类型为iaa类，符合条件的selectors有：ad_impression_num 和 p_date
const newConfig = {
    chartCode: 2429,
    // 通过指定规则：displaySetting里的gameType 是否存在当前游戏的gameType，筛选出需要的selectors
    selectors: [
        {
            "fieldName": "ad_impression_num",
            "displayName": "广告请求PV",
            "displaySetting": "{\"color\":\"#1D59F2\",\"gameType\":[\"iaa\",\"iaap\"],\"unit\":\"次\"}",
            ...
        },
        {
            "fieldName": "p_date",
            "displaySetting": "{\"gameType\":[\"iaa\",\"iaap\", \"iap\"]}",
            ...
        }
    ],
    needSelectorsfieldName: ['ad_impression_num', 'p_date'] // 新增字段用于请求chartData
    ...其他原有参数
}
**/
export function fillerConfig ( oldConfig: ChartsType, gameType: string ) {
    const newObject: NewSelectorConfigType = {
        needSelectorsfieldName: [], // 只有name，后续请求chartData时需要
        ...oldConfig,  // 把其他值继续拼好
        selectors:[]
    };
    const selectors = oldConfig && oldConfig.selectors || [];
    if(selectors) {
        for(const val of selectors) {
            const displaySetting = val.displaySetting && JSON.parse(val.displaySetting);
            if(displaySetting && displaySetting.gameType.includes(gameType)) {
                newObject.needSelectorsfieldName.push(val.fieldName);
                newObject.selectors.push(val)
            }
        }
    }

    return newObject;
};

export function filterBatchChartItemSelector(item: ChartsType) {
    const resultArray = item.selectors.map((val: SelectorsType) => val.fieldName)
    // console.log('filterBatchChartItemSelector', resultArray)
    return resultArray
}

// 过滤出需要select 类型的
export function fillterSelectList(conditions: ConditionsType[]) {
    const dv = new DataSet.DataView().source(conditions);
    const newSelects = dv.transform({
        type: 'filter',
        callback(row) {
            return row.fieldType === 'select'
        },
    }).rows;

    return newSelects;
}

// 生成默认的查询条件
export function createFilterForm(conditions: ConditionsType[], appId: string) {

    const formArray = conditions.map( (item: ConditionsType) => {
        let fieldValue: number | string = item.defaultValue;
        if(item.fieldName === 'app_id') {
            fieldValue = appId
        }
        // 默认选中近7天
        if(item.fieldName === 'start_time') {
            fieldValue = buttonList[1].value[0]
        }
        if(item.fieldName === 'end_time') {
            fieldValue = buttonList[1].value[1]
        }
        return {
            fieldName: item.fieldName,
            fieldValue: fieldValue,
        }
    })

    return formArray;
}

// 生成留存分析-card的查询条件
export function createRetentionCardFiterForm (conditions: ConditionsType[], appId: string) {
    const formArray = conditions.map( (item: ConditionsType) => {
        let fieldValue: number | string = item.defaultValue;
        if(item.fieldName === 'app_id') {
            fieldValue = appId
        }
        if(item.fieldName === 'start_time') {
            // 默认展示7天前的数据
            fieldValue = defaultRetentionCardTime;
        }
        if(item.fieldName === 'end_time') {
            // 默认展示7天前的数据
            fieldValue = defaultRetentionCardTime;
        }
        return {
            fieldName: item.fieldName,
            fieldValue: fieldValue,
        }
    })
    return formArray;
}

// 昨天、近7天、近30天的 时间format
export function dateFn(addDayNumber: number = -1) {
    const initTime = addDays(new Date(), -1); // 昨天
    // 如果选择的是昨天，则开始时间和结束时间都是 initDate
    if(addDayNumber === -1) {
        return [initTime.getTime(), initTime.getTime()]
    }
    // 近3天/近7天 ,结束时间应该为昨天（initDate），开始时间是昨天-3天
    const startTime = addDays(initTime, addDayNumber).getTime();
    const endTime = initTime.getTime();
    return [startTime ,endTime]
}

// 将date picker 返回的[xx,xx]赋值给filterForm 里的start_time 和 end_time;
export function changeFilterFormDate(form: FilterFormItemType[], val: number[]) {
    const timechangeForm = cloneDeep(form);
    const startTimeIndex = timechangeForm.findIndex((item: FilterFormItemType) => item.fieldName === 'start_time')
    const endTimeIndex = timechangeForm.findIndex((item: FilterFormItemType) => item.fieldName === 'end_time')
    timechangeForm[startTimeIndex]!.fieldValue = val[0]
    timechangeForm[endTimeIndex]!.fieldValue = val[1];
    return timechangeForm;
}


// 统一处理请求Conditions
export function queryConditions(oldParams: FilterFormItemType[]) {
    const dv = new DataSet.DataView().source(oldParams);
    return dv.transform({
        type: 'filter',
        callback(row) {
            // 返回fieldValue有值的row，为空直接删除
            // 例如：product 和 platform 选择 全部（全部的fieldValue='') 时，需要把这个字段删掉
            return row.fieldValue
        },
    }).rows;
}

// 根据游戏类型组合成新的指标详情-config 按照chartSetting 分类
export function fillerRequestChartId(detailPannel: PanelsType, gameType: string) {
    const chartList = detailPannel.charts;
    // 第一步，获取当前游戏需要的chartId,组合成新的数组[{},{}]
    const newObject: NewChartListConfigType = {
        needChartIds: [], // 只有name，后续请求chartData时需要
        chartList:[]
    };
    if(chartList.length > 0) {
        for(const val of chartList) {
            const chartSetting = val.chartSetting && JSON.parse(val.chartSetting);
            if(chartSetting.gameType && chartSetting.gameType.includes(gameType)) {
                newObject.needChartIds.push(val.chartId);
                newObject.chartList.push(val)
            }
        }
    }
    return newObject;
    // chartList = chartList.
}

export function percentageToNumber(percentageString: string) {
    return Number(percentageString.replace(/%/, ''));
}

// 判断现在双Y轴折线图有 1个还是两个Y轴，如果只有一个单位，则只展示当前单位的Y轴
export function showUnitYaxis(legend: any, chartData: ChartType) {
    // 获取当前为true的select，然后再拿到对应的单位[{'val': '次'}],最终重组合成=>['次', '收入']；
    const showSelecteds: string[] = [];
    const units: string[] = [];
    for(const key in legend.selected) {
        if(legend.selected[key]) showSelecteds.push(key)
    }
    chartData.titles.map((item: any) => {
        if(showSelecteds.includes(item.fieldName)) {
            const displaySetting = item.displaySetting && JSON.parse(item.displaySetting);
            units.push(displaySetting.unit || '')
        }
    })
    return [...new Set(units)];
}

// 过滤时间，暂时没有用到
// export function tableDataFilter(data: any) {
//     return data.records.map((m: any) => {
//         m.p_date = format(new Date(Number(m.p_date)), "yyyy-MM-dd");
//         return m;
//     })
// }

// 过滤出当前需要请求的table chartId
export function fitlerTableChartId(gameType: string, tablePannel: PanelsType) {
    return tablePannel.charts.find((val: ChartsType) => {
        const chartSetting = val.chartSetting && JSON.parse(val.chartSetting);
        if(gameType === chartSetting.type) return val
    })!.chartId
}

// 过滤出某个config里的setting（displaySetting or chartSetting) 信息，setting原格式为json string；
export function filterSetting(setting: string) {
    const settingObj = setting && JSON.parse(setting) ;
    if(settingObj) return settingObj;
    return {};
}

export const pickerOptions = {
    disabledDate(time: Date) {
        // 只能查询2024.4.1 至 昨天 之间的数据
        const yesterday = addDays(new Date(), -1).getTime();
        const startDate = new Date('2024/4/1').getTime();
        return time.getTime() > yesterday || time.getTime() < startDate;
    }
}


/**
 *  此处逻辑用处：
 *  举个例子，后端返回一个chart，chart里有11个指标，按照指标group，拆分成前端需要的5个chart
 *  此处逻辑对前端来说处理太重了 暂时废弃，注释先保留一段时间
 * function filterDetaiPannel(pannelData: any) {
    // 第一步找到我们需要的指标
    const newConfig = fillerConfig(pannelData.charts.find(item => item.chartType === 'line'));
    console.log('详情过滤后的指标config', newConfig)
    const { needSelectorsfieldName, selectors } = newConfig;
    // 第二步按照group分组
    const dv = new DataSet.DataView().source(selectors);
    const test2 = dv.transform({
        type: 'pick',
        fields: ['columnGroup'],
    }).rows;
    // 去重后的结果
    const map = new Map();
    let newDetailArray = test2.filter( v => !map.has(v.columnGroup) && map.set(v.columnGroup, v));
    // 去重后删掉为-1的
    newDetailArray = new DataSet.DataView().source(newDetailArray).transform({
        type: 'filter',
        callback(row) {
            return Number(row.columnGroup) !== -1
        },
    }).rows;
    console.log('test',newDetailArray);

    newDetailArray = newDetailArray.map((item) => {
        const filedNameList: string[] = [];
        const fillerSelectors = new DataSet.DataView().source(selectors).transform({
            type: 'filter',
            callback(row) {
                if(row.columnGroup === item.columnGroup) {
                    filedNameList.push(row.fieldName)
                }
                return row.columnGroup === item.columnGroup || Number(row.columnGroup) === -1
            },
        }).rows;
        filedNameList.push('p_date');

        return {
            ...item,
            title: "测试title",
            filedNameList,
            selectors: fillerSelectors,
        }
    })

    // const test3 = new DataSet.DataView().source(test2).transform({
    //     type: 'filter',
    //     callback(row) {
    //         console.log('row', row)
    //         return true
    //     },
    // });
    console.log('test3', newDetailArray);
    // 第三步拼接成新的组合
    return newDetailArray;
}
**/
